module.exports = __webpack_public_path__ + "media/images/calendar-1972e1fe707c698efa54332f2b4c8a55.svg";